document.addEventListener("DOMContentLoaded", function () {
  var el = document.getElementById("expand-tabs");
  if (el) {
    el.addEventListener("click", (event) => {
      window.MyProfile.toggleExpandedTabs(event);
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  var el = document.getElementById("reset-input-button");
  if (el) {
    el.addEventListener("click", () => {
      window.Inputs.resetInput("reset-input");
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('[id="reveal-secret"]').forEach((el) => {
    el.addEventListener("click", () => {
      window.SecretKey.toggleRevealPassword(el.value);
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('[id="copy-secret"]').forEach((el) => {
    el.addEventListener("click", () => {
      window.SecretKey.copySecretToClipboard(el.value);

      const textNode = el.childNodes[el.childNodes.length - 1];
      textNode.nodeValue = " Key Copied";

      setTimeout(() =>
        textNode.nodeValue = " Copy Key"
        , 2000)
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  var el = document.getElementById("toggle-hidden");
  if (el) {
    el.addEventListener("click", () => {
      window.MyProfile.toggleHidden(el.getAttribute("data-value"));
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  var el = document.getElementById("toggle-child-hidden");
  if (el) {
    el.addEventListener("click", (event) => {
      window.SuperInspector.toggleChildHidden(event);
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  var el = document.getElementById("manual-link");
  if (el) {
    el.addEventListener("click", () => {
      const email = el.getAttribute("data-email");
      const url = el.getAttribute("data-url");
      manualEmail(email, url);
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll(".pms-quick-code-search")
    .forEach((el) => window.SearchDropdown.init(el));
});

document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll(".toggle-hidden-action")
    .forEach((el) => window.ToggleHidden.init(el));
});

document.addEventListener("DOMContentLoaded", () => {
  document
    .querySelectorAll("[data-email-duration-parent]")
    .forEach((container) => {
      const parent = document.getElementById(
        container.dataset.emailDurationParent,
      );
      if (!parent) return;

      parent.addEventListener("change", () => {
        container
          .querySelectorAll('input[type="checkbox"]')
          .forEach((child) => {
            child.checked = parent.checked;
          });
      });

      container.querySelectorAll('input[type="checkbox"]').forEach((child) => {
        child.addEventListener("change", () => {
          if (!parent.checked) return;

          const anyChecked = Array.from(
            container.querySelectorAll('input[type="checkbox"]'),
          ).some((cb) => cb.checked);

          if (!anyChecked) {
            parent.checked = false;
            container.classList.add("opacity-50", "pointer-events-none");
          }
        });
      });
    });
});

document.addEventListener("DOMContentLoaded", () => {
  const root = document.getElementById("email-filing-settings");
  if (!root) return;

  const orgAutoFilingEnabled = root.dataset.orgAutoFilingEnabled === "true";
  const fileEmails = document.getElementById("user_settings_file_emails");
  const autoFileEmails = document.getElementById("user_settings_auto_file_emails");
  const delay = document.getElementById("user_settings_email_filing_delay");

  if (!fileEmails || !autoFileEmails || !delay) return;

  const setDisabled = (input, disabled) => {
    input.disabled = disabled;
    const hidden = root.querySelector(`input[type="hidden"][name="${input.name}"]`);
    if (hidden) hidden.disabled = disabled;
  };

  const setClass = (id, className, active) => {
    const el = document.getElementById(id);
    if (el) el.classList.toggle(className, active);
  };

  const refresh = () => {
    const autoDisabled = !orgAutoFilingEnabled || !fileEmails.checked;
    const delayDisabled = autoDisabled || !autoFileEmails.checked;

    setDisabled(autoFileEmails, autoDisabled);
    delay.disabled = delayDisabled;

    setClass("email-filing-label", "text-mt-grey-lighter", autoDisabled);
    setClass("email-filing-delay-label", "text-mt-grey-lighter", delayDisabled);
    setClass("email-filing-delay-group", "text-mt-grey-lighter", delayDisabled);
  };

  fileEmails.addEventListener("change", refresh);
  autoFileEmails.addEventListener("change", refresh);
  refresh();
});

// Support widget toggle
document.addEventListener("DOMContentLoaded", function () {
  var toggle = document.querySelector(
    '[data-role="admin-menu-support-link"], [data-role="super-menu-support-link"]',
  );
  var widget = document.getElementById("support-widget");
  var closeBtn = document.getElementById("support-widget-close");

  if (!toggle || !widget || !closeBtn) return;

  toggle.addEventListener("click", function (e) {
    e.preventDefault();
    widget.classList.toggle("hidden");
  });

  closeBtn.addEventListener("click", function () {
    widget.classList.add("hidden");
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const switcher = document.getElementById("report-team-switcher");
  if (switcher) {
    switcher.addEventListener("change", () => {
      window.location.href = switcher.value;
    });
  }
});

function manualEmail(email, invitationLink) {
  const br = "%0D%0A";
  const subject = "Welcome to Mitimes";
  var body = "";
  body += "Your Mitimes account has been set up and is ready for you to use.";
  body += br + br;
  body += "Please use the link below to activate your account:";
  body += br + br;
  body += invitationLink;
  body += br + br;
  body += "Thank you";

  window.location.href =
    "mailto:" + email + "?subject=" + subject + "&body=" + body;
  return false;
}
